import loadable from '@loadable/component';
import { NO_SSR } from 'shared/constants/loadable';

export const ActionsCentersLoadable = loadable(() => import('./ActionsCenters'), { ssr: NO_SSR });
